module.exports = __webpack_public_path__ + "static/media/high_on_waist.38b54363.svg";